import { atom } from 'jotai';

import type { LocationAggregationState } from './LocationAggregationEntity';

export const initialLocationAggregationsState: LocationAggregationState = {
  error: false,
  isLoading: false,
  regions: [],
  areas: [],
};

export const locationAggregationsAtom = atom<LocationAggregationState>({
  ...initialLocationAggregationsState,
});
